import React, { useState, useEffect, useContext } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { Button } from "@mui/material";
import circle from '../../Assets/Images/check-circle.svg'
import star from '../../Assets/Images/star.svg'

import AuthContext from "../../Context/AuthContext";

const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY}`);

const SignupPaymentConfirmation = () => {

  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [paymentPage, setPaymentPage] = useState("checking");
  const [isLoading, setIsLoading] = useState(true);
  const [setupComplete, setSetupComplete] = useState(false);
  const [currentHubUrl, setCurrentHubUrl] = useState("");
  const pi = searchParams.get("payment_intent");
  const { state } = useLocation()

  useEffect(() => {
    if (state && state.paymentPage) {
      setPaymentPage(state.paymentPage);
    }
  }, [state]);

  useEffect(() => {
    getPaymentProgress();
  }, []);

  const getPaymentProgress = () => {

    fetch(process.env.REACT_APP_API_URI + '/v4/organisation/payment/' + authCtx.orgId + '/completed', {
      method: 'PUT',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json', 'Authorization': authCtx.token }
    }).then(response => {
      return response.json();
    }).then(data => {
      if (data.status == "success") {
        // if(data.payment.status == "succeeded") {
        //   // createMembership(data.payment.metadata.user_id, data.payment.metadata.org_id);
        // } else {
        setTimeout(() => {
          createUrl();
          setPaymentPage("creating");
        }, 4000);
        // }
        // navigate("/results/" + id, { replace: true });
      } else {
        // setOpenSnackbar(true);
      }
    });

    // 	fetch(process.env.REACT_APP_API_URI + '/v1/stripe/checkPaymentIntent/' + pi, {
    //     method: 'GET',
    //     mode: 'cors',
    //     headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + authCtx.token }
    //   }).then(response => {
    //     return response.json();
    //   }).then(data => {
    // 		if(data.status == "success") {
    //       if(data.payment.status == "succeeded") {
    //         createMembership(data.payment.metadata.user_id, data.payment.metadata.org_id);
    //       } else {
    //         setTimeout(() => {getPaymentProgress();}, 4000);
    //       }
    //       // navigate("/results/" + id, { replace: true });
    //     } else {
    //       // setOpenSnackbar(true);
    //     }
    //   });

  }

  const createUrl = () => {

    fetch(process.env.REACT_APP_API_URI + '/v4/organisation/' + authCtx.orgId + '/acm', {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json', 'Authorization': authCtx.token }
    }).then(response => {
      return response.json();
    }).then(data => {
      // console.log(data);
      if (data.status == "success") {
        setPaymentPage("complete");
      } else {
        setTimeout(() => { createUrl(); }, 4000);
      }
    });

  }

  const createMembership = (userId, hubId) => {

    let jsonBody = JSON.stringify({ userId: userId, hubId: hubId });

    fetch(process.env.REACT_APP_API_URI + '/v2/hubs/' + hubId + '/membershipFromPayment', {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json', 'Authorization': authCtx.token },
      body: jsonBody,
    }).then(response => {
      return response.json();
    }).then(data => {
      // console.log(data);
      if (data.status == "success") {
        setCurrentHubUrl(data.hubUrl);
        setIsLoading(false);
      } else {
        // setOpenSnackbar(true);
      }
    });

  }

  const goToOverview = () => {
    navigate('/dashboard');
  }

  const showPaymentStatus = () => {

    // console.log("showPaymentStatus", state.paymentPage)

    switch (paymentPage) {

      case "checking":
        return <div className="confirmation-box">
          <CircularProgress style={{ 'color': '#F7D54D' }} size={60} />
          <div>
            <h2>Verifying Your Payment</h2>
            <p>Thank you for waiting! Once your payment is validated, we'll proceed with setting up your account.</p>
          </div>
          {/* <button onClick={(e) => goToOverview(e)}>
          <span id="button-text" style={{ cursor: "pointer" }}>
            GO TO OVERVIEW
          </span>
      	</button> */}
        </div>

      case "creating":
        return <div className="confirmation-box">
          <CircularProgress style={{ 'color': '#F7D54D' }} size={60} />
          <div>
            <h2>Your Account is Almost Ready</h2>
            <p>Your payment was successful! We'll have your account ready in a few minutes.</p>
          </div>
          {/* <button onClick={(e) => goToOverview(e)}>
					<span id="button-text" style={{ cursor: "pointer" }}>
						GO TO OVERVIEW
					</span>
				</button> */}
        </div>

      case "complete":
        return <div className="confirmation-box">
          <img src={circle} alt="" />
          <div>
            <h2>Account Created.</h2>
            <p>Your new church profile has been completed. Click the below button to explore the Scatter environment, invite other team members, or learn how to start collecting survey responses from your congregation.</p>
          </div>
          <button onClick={(e) => goToOverview(e)}>
            <span id="button-text" style={{ cursor: "pointer" }}>
              GO TO OVERVIEW
            </span>
          </button>
        </div>

      default: return null;
    }

  }

  return (
    <div className="container signup-payment-confirm-container">
      <h1>Payment Setup</h1>
      {showPaymentStatus()}
    </div>
  )
}

export default SignupPaymentConfirmation;
